import { Route, Redirect } from "react-router-dom";
import authService from "../_services/authService";

export default function BranchPrivateRoute({
	component: Component,
	children,
	render,
	...rest
}) {
	const user = authService.getCurrentUser();
	return (
		<Route
			{...rest}
			render={({ location }) =>
				user && user?.type === 3 ? (
					children
				) : (
					<Redirect
						to={{
							pathname: "/branch",
							state: { from: location },
						}}
					/>
				)
			}
		/>
	);
}
